/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BulkUploadErrorMessage,
    BulkUploadErrorMessageFromJSON,
    BulkUploadErrorMessageFromJSONTyped,
    BulkUploadErrorMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface BulkUploadDataError
 */
export interface BulkUploadDataError {
    /**
     * 
     * @type {string}
     * @memberof BulkUploadDataError
     */
    dataRow?: string | null;
    /**
     * 
     * @type {Array<BulkUploadErrorMessage>}
     * @memberof BulkUploadDataError
     */
    messages?: Array<BulkUploadErrorMessage> | null;
}

export function BulkUploadDataErrorFromJSON(json: any): BulkUploadDataError {
    return BulkUploadDataErrorFromJSONTyped(json, false);
}

export function BulkUploadDataErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUploadDataError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataRow': !exists(json, 'dataRow') ? undefined : json['dataRow'],
        'messages': !exists(json, 'messages') ? undefined : (json['messages'] === null ? null : (json['messages'] as Array<any>).map(BulkUploadErrorMessageFromJSON)),
    };
}

export function BulkUploadDataErrorToJSON(value?: BulkUploadDataError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dataRow': value.dataRow,
        'messages': value.messages === undefined ? undefined : (value.messages === null ? null : (value.messages as Array<any>).map(BulkUploadErrorMessageToJSON)),
    };
}


